import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = ["poster"];
const _hoisted_2 = ["src"];
import { onMounted, onUnmounted } from 'vue';

import { ref } from 'vue';
export default /*#__PURE__*/_defineComponent({
  __name: 'Video',
  props: {
    fileUrl: {},
    posterUrl: {}
  },
  emits: ['error', 'play', 'pause', 'ended', 'loadedmetadata'],
  setup(__props, {
    emit: __emit
  }) {
    const props = __props;
    const emit = __emit;
    const video = ref(null);
    const errorHandler = () => {
      emit('error', ref);
    };
    const playHandler = () => {
      emit('play', ref);
    };
    const pauseHandler = () => {
      emit('pause', ref);
    };
    const endedHandler = () => {
      emit('ended', ref);
    };
    const loadedmetadataHandler = () => {
      emit('loadedmetadata', ref);
    };
    onMounted(() => {
      video.value?.addEventListener('error', errorHandler);
      video.value?.addEventListener('play', playHandler);
      video.value?.addEventListener('pause', pauseHandler);
      video.value?.addEventListener('ended', endedHandler);
      video.value?.addEventListener('loadedmetadata', loadedmetadataHandler);
    });
    onUnmounted(() => {
      video.value?.removeEventListener('error', errorHandler);
      video.value?.removeEventListener('play', playHandler);
      video.value?.removeEventListener('pause', pauseHandler);
      video.value?.removeEventListener('ended', endedHandler);
      video.value?.removeEventListener('loadedmetadata', loadedmetadataHandler);
    });
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("video", {
        ref_key: "video",
        ref: video,
        controls: "",
        poster: _ctx.posterUrl
      }, [_createElementVNode("source", {
        src: _ctx.fileUrl
      }, null, 8, _hoisted_2), _createTextVNode(" Your browser does not support the video tag. ")], 8, _hoisted_1);
    };
  }
});